import { Label } from '@/components/ui/catalyst/fieldset';
import { Radio, RadioField, RadioGroup } from '@/components/ui/catalyst/radio';
import {
  DestinationChangeReason,
  type ResendReason,
  ResendSameReason,
} from '@/types/provider-destinations';

const SAME_DESTINATION_OPTIONS: { value: ResendReason; label: string }[] = [
  {
    value: ResendSameReason.NO_RESPONSE_SLA_EXCEEDED,
    label: 'No response within SLA',
  },
  { value: ResendSameReason.FAX_FAILED, label: 'Fax transmission failed' },
  {
    value: ResendSameReason.PROVIDER_SAID_NOT_RECEIVED,
    label: 'Provider says not received',
  },
  {
    value: ResendSameReason.MISSING_DOCS_OR_CORRECTED_FORM,
    label: 'Missing documents',
  },
  {
    value: ResendSameReason.OTHER,
    label: 'HIPAA package issue or need to restart',
  },
];

const DIFFERENT_DESTINATION_OPTIONS: {
  value: ResendReason;
  label: string;
}[] = [
  {
    value: DestinationChangeReason.WRONG_NUMBER_OR_INBOX,
    label: 'Wrong number',
  },
  {
    value: DestinationChangeReason.NOT_RIGHT_DEPARTMENT,
    label: 'Wrong department',
  },
  {
    value: DestinationChangeReason.FAX_FAILED,
    label: 'Fax transmission failed',
  },
  {
    value: DestinationChangeReason.PROVIDER_REJECTED_DESTINATION,
    label: 'Provider rejected',
  },
];

interface ResendReasonSelectorProps {
  isDestinationChange: boolean;
  value: ResendReason | null;
  onChange: (reason: ResendReason) => void;
}

export const ResendReasonSelector = ({
  isDestinationChange,
  value,
  onChange,
}: ResendReasonSelectorProps) => {
  const options = isDestinationChange
    ? DIFFERENT_DESTINATION_OPTIONS
    : SAME_DESTINATION_OPTIONS;

  return (
    <div className="space-y-3">
      <p className="text-sm font-medium text-zinc-900">Reason for resend</p>
      <RadioGroup
        value={value ?? undefined}
        onChange={(val: string) => onChange(val as ResendReason)}
      >
        {options.map((option) => (
          <RadioField key={option.value}>
            <Radio value={option.value} color="indigo" />
            <Label>{option.label}</Label>
          </RadioField>
        ))}
      </RadioGroup>
    </div>
  );
};
